import * as React from 'react';
import { api, handleApiError } from 'services/api';
import { downloadFile } from 'utils';

type Response = {
  base64: string;
  ext: string;
  filename: string;
}

export const useDownloadDataImportSourceFile = () => {
  const downloadSourceFile = React.useCallback(async (dataImportId: number) => {
    try {
      const { data } = await api.get<Response>(`/inventory/download-source-file/${dataImportId}`);
      await downloadFile({
        base64: data.base64,
        filename: data.filename,
      });
    } catch (error) {
      throw handleApiError(error);
    }
  }, []);

  return {
    downloadSourceFile,
  }
}